import { render } from "./DColumn.vue?vue&type=template&id=0119f5d5&scoped=true"
import script from "./DColumn.vue?vue&type=script&lang=js"
export * from "./DColumn.vue?vue&type=script&lang=js"

import "./DColumn.vue?vue&type=style&index=0&id=0119f5d5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0119f5d5"]])

export default __exports__